module.exports = __webpack_public_path__ + "static/media/creating-assigning.e0635d11.png";